import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { verifyMfaLogin } from "../../crud/auth.crud";
import * as utils from "../../../_metronic/utils/utils";

function MfaVerify({ mfaData, onBack, login }) {
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const inputRefs = useRef([]);

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newCode = [...code];
    newCode[index] = value.slice(-1);
    setCode(newCode);
    setError("");

    if (value && index < 5 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (
      e.key === "Backspace" &&
      !code[index] &&
      index > 0 &&
      inputRefs.current[index - 1]
    ) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 6);
    const newCode = [...code];

    for (let i = 0; i < pastedData.length; i++) {
      newCode[i] = pastedData[i];
    }

    setCode(newCode);

    const nextIndex = Math.min(pastedData.length, 5);
    if (inputRefs.current[nextIndex]) {
      inputRefs.current[nextIndex].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fullCode = code.join("");

    if (fullCode.length !== 6) {
      setError("Digite o código de 6 dígitos.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await verifyMfaLogin(
        mfaData.email,
        mfaData.mfa_token,
        fullCode
      );
      utils.setStorage("authToken", res.data.token, null);
      login(res.data);
    } catch (err) {
      if (err.response?.status === 429) {
        setError("Muitas tentativas. Aguarde um minuto e tente novamente.");
      } else {
        setError(
          err.response?.data?.error || "Código inválido. Tente novamente."
        );
      }
      setCode(["", "", "", "", "", ""]);
      if (inputRefs.current[0]) {
        inputRefs.current[0].focus();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="kt-login__head"></div>

      <div className="kt-login__body">
        <div className="kt-login__form">
          <div className="kt-login__title">
            <h3>Verificação em duas etapas</h3>
          </div>

          <p className="text-muted mb-4">
            Digite o código de 6 dígitos do seu aplicativo autenticador.
          </p>

          <form onSubmit={handleSubmit}>
            {error && (
              <div role="alert" className="alert alert-danger">
                <div className="alert-text">{error}</div>
              </div>
            )}

            <div className="form-group">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                {code.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    onPaste={handlePaste}
                    style={{
                      width: "45px",
                      height: "55px",
                      fontSize: "24px",
                      textAlign: "center",
                      border: "1px solid #e2e5ec",
                      borderRadius: "4px",
                      outline: "none",
                    }}
                    disabled={loading}
                  />
                ))}
              </div>
            </div>

            <div
              className="kt-login__actions"
              style={{ display: "flex", gap: "10px" }}
            >
              <button
                type="button"
                onClick={onBack}
                className="btn btn-secondary btn-elevate"
                disabled={loading}
              >
                Voltar
              </button>

              <button
                type="submit"
                disabled={loading || code.join("").length !== 6}
                className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                  {
                    "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading,
                  }
                )}`}
                style={{ flex: 1 }}
              >
                Verificar
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default connect(null, auth.actions)(MfaVerify);
